<app-modal
  [options]="modalOptions"
  (closeClick)="close()"
  (negativeClick)="close()"
  (positiveClick)="unlock()"
  [isSaving]="isUnlocking"
>
  <div class="explore-meplis">
    <img
      class="explore-meplis__logo logo"
      src="images/meplis-logo.webp"
      alt="Meplis"
    />
    <h4>{{ 'HUBS.EXPLORE_MEPLIS_SUBTITLE' | translate }}</h4>
    <ul class="explore-meplis__feature-list">
      @for (feature of features; track feature) {
<li class="explore-meplis__feature-item">
        <fa-icon class="explore-meplis__feature-icon" [icon]="feature.icon | faIconName"></fa-icon>
        <span class="explore-meplis__feature-label">
          {{ feature.labelKey | translate }}
        </span>
      </li>
}
    </ul>
  </div>
</app-modal>
